﻿import {ComponentType, createElement, LazyExoticComponent, memo} from "react";

export function createFakeLazy<T extends ComponentType<any>>(Component: T): LazyExoticComponent<T> {
	const MemoComponent = memo(Component);
	const fakeLazy = Object.assign(
		(props: any) => createElement(MemoComponent, props),
		{
			$$typeof: Symbol.for("react.lazy"),
			_payload: {
				_status: 1, // Resolved
				_result: MemoComponent
			},
			_init: true
		}
	);

	return fakeLazy as unknown as LazyExoticComponent<T>;
}
